import axios from "axios";

export default {
    updateInvoiceStatuses: async (payload) => {
        const {data} = await axios.post(`/sales_invoices/update_invoices_paid_sum/${payload.account_id}`, payload)
        return data
    },
    createInvoiceFromClient: async (invoice, force = false) => {
        const {data} = await axios.post(`/sales_invoices/${invoice.account_id}/new-invoice`, invoice, {params: {force}})
        return data
    },
}
